import { Component, OnInit } from '@angular/core';

import {Router} from '@angular/router';
import {RestapiService} from '../restapi.service';

@Component({
  selector: 'app-help-doc',
  templateUrl: './help-doc.component.html',
  styleUrls: ['./help-doc.component.css']
})
export class HelpDocComponent implements OnInit {

  constructor(private router: Router, private _rest: RestapiService) { }
  respObject: any;
  respvObject: any;
  fileData: any;
  hasData=false;
  dFile = "";
  downLoadPath=this._rest.FILE_PATH;
  loaderVisibility=false;
  
  docTitle=""
  

  ngOnInit(): void {
    this.loaderVisibility=true;
  
    this.docTitle="";
    this.dFile="";

  	const req = {}
      this._rest.getHelpDoc(req).subscribe((res) => {
        this.respvObject = res;
        console.log(res);
        if(this.respvObject.error==0){
        	this.fileData = this.respvObject.resp;
          // console.log(this.fileData);
          this.fileData.docFile = 'PDF_User_Manual_-_Online_MIS_Admin.pdf';
          this.fileData.docTitle = "Admin User Manual";
          // this.fileData = 'PDF_User_Manual_-_Online_MIS_Admin.pdf';
        } else {
        	this.hasData=false;
        }
        this.loaderVisibility=false;
      });
  }
  uploadDoc(){
    this.loaderVisibility=true;
  	const docFile = <HTMLInputElement>document.getElementById('docFile');
  	if(this.docTitle!="" && docFile.files[0]!= undefined){
  		const fd = new FormData();
  		fd.append("docTitle",this.docTitle);
  		fd.append("docFile",docFile.files[0]);
  		this._rest.helpDocUpload(fd).subscribe((res) => {
        	this.respObject = res;
        	if(this.respObject.error==0){
        		alert("File uploaded successfully");
        		//window.location.reload();
            this.ngOnInit();
        	} else {
        		alert(this.respObject.errorMessage);
        	}
        });
  	} else {
  		alert("All Fields are required.");
  	}

  }
  deleteDoc(id){
  	if(confirm("Are you sure to delete?")){
      const fd = {};
      fd["id"] = id;
  		//alert("deleted");
      this._rest.delHelpDoc(fd).subscribe((res) => {
        console.log(res);
        this.respObject = res;
        if(this.respObject.error==0){
          alert("Help Document has been deleted successfully.");
          this.ngOnInit();
        } else {
            alert(this.respObject.errorMessage);
        }
      });
  	}
  }

}
